import { useEffect, useRef, useState } from 'react';
import { mediaUrl } from '../api/client';

const FALLBACK_POSTER = '/assets/images/section-5.jpg';

function shouldSkipVideo() {
  if (typeof navigator === 'undefined') return false;

  const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;

  if (connection?.saveData) return true;
  if (connection?.effectiveType === 'slow-2g' || connection?.effectiveType === '2g') return true;

  return false;
}

export default function HeroVideo({ videoUrl, posterUrl }) {
  const videoRef = useRef(null);
  const [loadVideo, setLoadVideo] = useState(false);
  const [ready, setReady] = useState(false);
  const poster = mediaUrl(posterUrl || FALLBACK_POSTER);

  useEffect(() => {
    if (shouldSkipVideo()) return undefined;

    let idleId;
    let timeoutId;

    if ('requestIdleCallback' in window) {
      idleId = window.requestIdleCallback(() => setLoadVideo(true), { timeout: 1500 });
    } else {
      timeoutId = window.setTimeout(() => setLoadVideo(true), 300);
    }

    return () => {
      if (idleId && 'cancelIdleCallback' in window) {
        window.cancelIdleCallback(idleId);
      }
      if (timeoutId) window.clearTimeout(timeoutId);
    };
  }, []);

  useEffect(() => {
    const video = videoRef.current;
    if (!loadVideo || !video) return undefined;

    const markReady = () => setReady(true);

    video.addEventListener('canplay', markReady);

    if (video.readyState >= 3) {
      markReady();
    }

    return () => video.removeEventListener('canplay', markReady);
  }, [loadVideo, videoUrl]);

  return (
    <>
      <div
        className={`hero__fallback${ready ? ' hero__fallback--hidden' : ''}`}
        style={{ backgroundImage: `url(${poster})` }}
        aria-hidden="true"
      />
      {loadVideo ? (
        <video
          ref={videoRef}
          className={`hero__native-video${ready ? ' hero__native-video--ready' : ''}`}
          src={mediaUrl(videoUrl)}
          poster={poster}
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
          aria-hidden="true"
        />
      ) : null}
    </>
  );
}
